<template>
    <div class="row mb-3"  name='myvacationlist'>
        <div class="col">
            <div class="card mb-2">
                <div class="card-body">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                            <th>{{ $trans.get('__JSON__.Date') }}</th>
                            <th class="text-end">{{ $trans.get('__JSON__.Days') }}</th>
                            <th>{{ $trans.get('__JSON__.Type') }}</th>
                            <th>{{ $trans.get('__JSON__.Comment') }}</th>
                            </tr>   
                        </thead>
                        <tbody>
                            <tr v-for="vacation in vacations" :key="vacation.id">
                                <td>{{ formatDate(vacation.start_at) }}</td>
                                <td class="text-end">{{ vacation.days }}</td>
                                <td>{{ $trans.get('__JSON__.' + descriptiontypes[vacation.type]) }}</td>
                                <td>{{ vacation.comment }}</td>
                            </tr>
                            <tr v-for="(vacation, k) in futurevacations" :key="k">
                                <td>{{ formatDate(vacation.start_at) }}</td>
                                <td class="text-end"><span v-if="vacation.from_flextime">0 (</span>{{ (vacation.workdays * -1) }}<span v-if="vacation.from_flextime">)</span></td>
                                <td>
                                    <span v-if="vacation.from_flextime">{{ $trans.get('__JSON__.From flextime') }}</span>
                                    <span v-if="!vacation.from_flextime">{{ $trans.get('__JSON__.future vacation') }}</span>
                                </td>
                                <td>
                                    {{ formatDate(vacation.start_at) }}
                                    <span v-if="vacation.start_at != vacation.end_at"> - {{ formatDate(vacation.end_at) }}</span>
                                    <span v-if="vacation.granted">&nbsp;{{ $trans.get('__JSON__.granted') }} </span>
                                    <span v-if="!vacation.granted">&nbsp;{{ $trans.get('__JSON__.requested') }} </span>
                                    <div class="d-inline" v-if="!vacation.granted">
                                        <button @click.stop="deleteVacationRequest(k)" class="d-inline ml-2 link" href="#">
                                            <span style="top: 4px;" class="material-symbols-outlined">delete</span>
                                        </button>
                                    </div>
                                    <div class="d-inline" v-if="vacation.granted">
                                        <button @click.stop="revokeVacation(k)" class="transparent d-inline ml-2 link" href="#" :disabled="vacation.hasOpenRevokeRequest">
                                            <span style="top: 4px;" class="material-symbols-outlined">delete</span>
                                        </button>
                                        <span v-if="vacation.hasOpenRevokeRequest" class="material-symbols-outlined text-success" style="font-size:15px;" v-tooltip
                                            :title="$trans.get('__JSON__.There is already a revoke request open')">
                                            info
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                </div>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <div class="modal" tabindex="-1" id="changerequest">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1>{{ $trans.get('__JSON__.Revoke vacation') }}</h1>
                    </div>
                    <div class="modal-body">
                        <span v-if="requestsend && revokeResult">{{ $trans.get('__JSON__.successfully send revoke request') }}</span>
                        <span v-if="requestsend && !revokeResult">{{ $trans.get('__JSON__.something went wrong with your request') }}</span>
                        <span v-if="!requestsend">{{ $trans.get('__JSON__.Are you sure you want to send a request to revoke your vacation?') }}</span><br><br>
                        <button v-if="!requestsend" class="btn btn-danger" @click="sendRevokeRequest">{{ $trans.get('__JSON__.Send revoke request') }}</button>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" @click="closeRevokeRequest">{{ $trans.get('__JSON__.close') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { ref, watch } from "vue";

export default {
    name: "MyVacationList",
    props: {
        employee_id: String,
        year: String,
        vacationtypes: String
    },
    data() {
        return {
            vacations: null,
            futurevacations: null,
            revokeId: null,
            revokeResult: null,
            requestsend: null,
            descriptiontypes: null,
        }
    },
    created() {
        this.getVacationData();
        this.descriptiontypes = JSON.parse(this.vacationtypes);
    },
    mounted() {
    },
    methods: {
        getVacationData() {
            axios
                .get("/api/employees/" + this.employee_id + '/vacationdata', {
                    params: {
                        year: this.year
                    }
                })
                .then((resp) => {
                    this.vacationdata = resp.data;
                    this.vacations = this.vacationdata.vacations;
                    this.futurevacations = this.vacationdata.futureVacations;
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });

        },
        formatDate(date) {
            if (date == null) {
                return null;
            }
            var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
        },
        deleteVacationRequest(index) {
            if (confirm("Are you sure you want to delete the vacation request?")) {
                axios
                    .delete("/api/vacations/" + this.futurevacations[index].id)
                    .then((resp) => {
                        self.errors = [];
                        this.getVacationData();
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    });
            }
        },
        closeRevokeRequest() {
            $('#changerequest').modal('hide');
        },
        revokeVacation(index) {
            if(this.futurevacations[index].hasOpenRevokeRequest){
                alert(this.$trans.get("__JSON__.There is already a revoke request open"));
                return false;
            }
            this.requestsend = false;
            $('#changerequest').modal({ backdrop: 'static', keyboard: false });
            $('#changerequest').modal('show');
            this.revokeId = this.futurevacations[index].id;
        },
        sendRevokeRequest() {
            axios
                .post("/api/employees/" + this.employee_id + "/revokerequest", {
                    absenceid: this.revokeId,
                })
                .then((resp) => {
                    this.requestsend = true;
                    this.revokeResult = resp.data.res
                    self.errors = [];
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                });
        }
    }
}
</script>

<style lang="scss"></style>
